import React from 'react';
import { isBrowser } from 'react-device-detect';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import LuckyDaysLogo from '@/components/UI/Logos/LuckyDaysLogo';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { ModalLayout } from '@/features/modal/modals/ModalLayout';
import { Button } from '@/components/buttons/Button';
import { openDrawer } from '@/store/ui/actions';
import { DrawerName } from '@/store/ui/reducers';
import { BaseModalProps, MODALS } from '@/features/modal/types';
import { useModal } from '@/features/modal/useModal';

export const FailedLoginSmsModal = ({ closeModal }: BaseModalProps) => {
  const dispatch = useDispatch();
  const navigate = useAbsoluteNavigate();
  const intl = useIntl();
  const { openModal, resetModals } = useModal();

  function helpClickHandler() {
    closeModal();

    if (isBrowser) {
      setTimeout(() => {
        dispatch(openDrawer(DrawerName.Help));
      }, 200);
    } else {
      navigate('/help');
    }
  }

  const onForgotPasswordClicked = () => {
    navigate('/forgot-password-sms');
    resetModals();
  };

  const onLoginAgainClicked = () => {
    openModal(MODALS.LOGIN_SMS);
  };

  const onLoginViaEmailClicked = () => {
    openModal(MODALS.LOGIN);
  };

  return (
    <ModalLayout close={closeModal}>
      <div className="grid grid-cols-1 gap-6 justify-items-center">
        <LuckyDaysLogo />
        <div className="text-center">{intl.formatMessage({ id: 'failedLogin.sms.text' })}</div>
        <div className="grid grid-cols-1 gap-4 justify-self-stretch">
          <Button
            type="button"
            onClickHandler={onForgotPasswordClicked}
            text={intl.formatMessage({ id: 'failedLogin.text.resetPassword' })}
          />
          <Button
            type="button"
            onClickHandler={helpClickHandler}
            text={intl.formatMessage({ id: 'failedLogin.text.contactSupport' })}
          />
          <Button
            type="button"
            onClickHandler={onLoginAgainClicked}
            text={intl.formatMessage({ id: 'failedLogin.text.tryAgain' })}
          />
          <div className="border-t-2 pt-4 text-center">
            {intl.formatMessage({ id: 'failedLogin.sms.loginViaEmail.title' })}
          </div>
          <Button
            type="button"
            onClickHandler={onLoginViaEmailClicked}
            text={intl.formatMessage({ id: 'failedLogin.sms.loginViaEmail.button' })}
          />
        </div>
      </div>
    </ModalLayout>
  );
};
